import styled from "styled-components";


export const DisabledMemberContainer = styled.div`
  margin: auto;
  width: 100%;
`;
export const DisabledMemberContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 450px;
  background: #FFFFFF;
  border-radius: 6px;
  padding: 2rem;
  margin: auto;
`;
export const DisabledMemberTitle = styled.div`
  font-size: 20px;
  color: #002E5C;
  font-weight: 700;
`;
export const DisabledMemberDescription = styled.div`
  font-size: 16px;
  color: #002E5C;
  font-weight: 400;
  width: 90%;
  text-align: center;
`;